import { render, staticRenderFns } from "./LoyaltyMemberCreateForm.vue?vue&type=template&id=8f5310f8&"
import script from "./LoyaltyMemberCreateForm.vue?vue&type=script&lang=js&"
export * from "./LoyaltyMemberCreateForm.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyMemberCreateForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports